module.exports = __webpack_public_path__ + "static/36575D_3_0-ca1f3cafcc44ae7a0e9c5baca4de4f64.woff";